import { RouteLayoutProps } from "../Components/RouteLayout";
import BlankLayout from "../Components/Layouts/BlankLayout";
import WithHeader from "../Components/Layouts/WithHeader";
import ManagementLayout from "../Components/Layouts/ManagementLayout";
import AttendanceOnlineChat from "../Pages/AttendanceOnlineChat";
import Attendances from "../Pages/Attendances";
import Home from "../Pages/Home";
import InitPage from "../Pages/InitPage";
import OrganicSchedules from "../Pages/OrganicSchedules";
import PrintScheduler from "../Pages/PrintScheduler";
import Schedules from "../Pages/Schedules";
import SchedulesInternal from "../Pages/SchedulesInternal";
import SearchSchedules from "../Pages/SearchSchedules";
import ServicePanel from "../Pages/ServicePanel";
import AttendanceLocalList from "../Pages/AttendanceLocal/List";
import NewAttendanceLocals from "../Pages/AttendanceLocal/Form/Novo";
import EditAttendanceLocals from "../Pages/AttendanceLocal/Form/Editar";
import AttendanceLocalDetails from "../Pages/AttendanceLocal/Details";
import EditDepartment from "../Pages/AttendanceLocal/Details/components/tabs/department/list/components/edit-department";
import AttendanceLocalDepartmentDetails from "../Pages/AttendanceLocal/Details/components/tabs/department/details";
import AttendanceLocalDepartmentQueueServiceTimeList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time/list";
import AttendanceLocalDepartmentQueueServiceTimeCreate from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time/form/create";
import AttendanceLocalDepartmentQueueServiceTimeComplementList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-complement/list";
import AttendanceLocalDepartmentQueueServiceTimeComplementCreate from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-complement/form/create";
import AttendanceLocalDepartmentQueueServiceTimeExceptionList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-exception/list";
import AttendanceLocalDepartmentQueueServiceTimeExceptionCreate from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-exception/form/create";
import AttendanceLocalDepartmentQueueServiceTimeComplementExceptionList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-complement-exception/list";
import AttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreate from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/queue/list/service-time-complement-exception/form/create";
import AttendanceLocalDepartmentGuicheServiceList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/guiche/list/service/list";
import AttendanceLocalDepartmentGuicheServiceComplementList from "../Pages/AttendanceLocal/Details/components/tabs/department/details/components/tabs/guiche/list/service-complement/list";
import TotemList from "../Pages/Totem/list";
import TotemCreate from "../Pages/Totem/form/create";
import TotemUpdate from "../Pages/Totem/form/update";
import TotemDuplicate from "../Pages/Totem/form/duplicate";
import TotemDetails from "../Pages/Totem/details";
import AppointmentCancellationsList from "../Pages/AppointmentCancellations/List";
import AppointmentCancellationDetails from "../Pages/AppointmentCancellations/details";
import AppointmentCancellationFormCreate from "../Pages/AppointmentCancellations/form/create";
import PriorityList from "../Pages/Priority/List";
import PriorityDetails from "../Pages/Priority/details";
import PriorityCreate from "../Pages/Priority/form/create";
import PriorityUpdate from "../Pages/Priority/form/update";
import AttendantList from "../Pages/Attendant/list";
import Rescheduling from "../Pages/Reschedulings";
import HomeAdmin from "../Pages/HomeAdmin";
import Users from "../Pages/Users";
import UsersDetails from "../Pages/Users/UsersDetails";

export const routeList: Array<RouteLayoutProps> = [
    {
        path: "/",
        exact: true,
        component: InitPage,
        layout: BlankLayout,
        isAuth: true,
    },
    {
        path: "/home",
        exact: true,
        component: Home,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/agendamento",
        exact: true,
        component: Schedules,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/agendamento_interno",
        exact: true,
        component: SchedulesInternal,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/consulta_agendamento",
        exact: true,
        component: SearchSchedules,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/atendimento",
        exact: true,
        component: Attendances,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/atendimento/:id",
        exact: true,
        component: AttendanceOnlineChat,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/atendimento_diario",
        exact: true,
        component: OrganicSchedules,
        layout: WithHeader,
        isAuth: true,
    },
    {
        path: "/imprimir_agendamento",
        exact: true,
        component: PrintScheduler,
        layout: BlankLayout,
        isAuth: true,
    },
    {
        path: "/painel_de_atendimento/:id",
        exact: true,
        component: ServicePanel,
        layout: BlankLayout,
        isAuth: true,
    },
    {
        path: "/admin",
        exact: true,
        component: HomeAdmin,
        layout: ManagementLayout,
        isAuth: true,
    },
    {
        path: "/locais-de-atendimento",
        exact: true,
        component: AttendanceLocalList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/novo",
        exact: true,
        component: NewAttendanceLocals,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/editar",
        exact: true,
        component: EditAttendanceLocals,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug",
        exact: true,
        component: AttendanceLocalDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:id",
        exact: true,
        component: AttendanceLocalDepartmentDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/editar/:id",
        exact: true,
        component: EditDepartment,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/tempo-servicos",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/tempo-servicos/novo",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/tempo-servicos-complementares",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeComplementList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/tempo-servicos-complementares/novo",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeComplementCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/excecao-tempo-servicos",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeExceptionList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/excecao-tempo-servicos/novo",
        exact: true,
        component: AttendanceLocalDepartmentQueueServiceTimeExceptionCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/excecao-tempo-servicos-complementares",
        exact: true,
        component:
            AttendanceLocalDepartmentQueueServiceTimeComplementExceptionList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/fila/:queue_id/excecao-tempo-servicos-complementares/novo",
        exact: true,
        component:
            AttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/guiche/:guiche_id/servicos",
        exact: true,
        component: AttendanceLocalDepartmentGuicheServiceList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/locais-de-atendimento/:slug/setor/:department_id/guiche/:guiche_id/servicos-complementares",
        exact: true,
        component: AttendanceLocalDepartmentGuicheServiceComplementList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/totens",
        exact: true,
        component: TotemList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/totens/novo",
        exact: true,
        component: TotemCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/totens/:id/editar",
        exact: true,
        component: TotemUpdate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/totens/:id/duplicar",
        exact: true,
        component: TotemDuplicate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/totens/:id",
        exact: true,
        component: TotemDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/atendentes",
        exact: true,
        component: AttendantList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento",
        ]
    },
    {
        path: "/cancelamentos",
        exact: true,
        component: AppointmentCancellationsList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/cancelamentos/novo",
        exact: true,
        component: AppointmentCancellationFormCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/cancelamentos/:id",
        exact: true,
        component: AppointmentCancellationDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/reagendamentos",
        exact: true,
        component: Rescheduling,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
        ]
    },
    {
        path: "/prioridades",
        exact: true,
        component: PriorityList,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
        ]
    },
    {
        path: "/prioridades/novo",
        exact: true,
        component: PriorityCreate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
        ]
    },
    {
        path: "/prioridades/:id/editar",
        exact: true,
        component: PriorityUpdate,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
        ]
    },
    {
        path: "/prioridades/:id",
        exact: true,
        component: PriorityDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
        ]
    },
    {
        path: "/usuarios",
        exact: true,
        component: Users,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento"
        ]
    },
    {
        path: "/usuarios/:id/informacoes",
        exact: true,
        component: UsersDetails,
        layout: ManagementLayout,
        isAuth: true,
        allowedRoles: [
            "Administrador",
            "Administrador de Atendimento",
            "Gerente de Atendimento",
            "Coordenador de Atendimento"
        ]
    },
];
